import { Component } from '@angular/core';
import { Observable, catchError, firstValueFrom, map, of, switchMap, tap } from 'rxjs';
import { DialogCreaCfgImpattoComponent } from 'src/app/page/configurazioni/cfg-impatti/dialog/dialog-crea-cfg-impatto/dialog-crea-cfg-impatto.component';
import { Impatto } from 'src/app/services/impatto/impatto.service';
import { SelezioneElementiQuestionarioComponent } from '../../selezione-elementi-questionario.component';

@Component({
  selector: 'app-selezione-impatti-materialita',
  templateUrl: '../../selezione-elementi-questionario.component.html',
  styleUrls: ['../../selezione-elementi-questionario.component.scss'],
  standalone: false,
})
export class SelezioneImpattiMaterialitaComponent extends SelezioneElementiQuestionarioComponent {
  override editElementoListaChk(idAmbito: string, idTematica: string, impatto?: any): void {
    impatto = super.addSettoreElemento(impatto);
    this._dialogCreaCfgImpatto(idAmbito, idTematica, impatto).subscribe();
  }

  override addElementoListaChk(idAmbito: string, idTematica: string): void {
    // posso passare la stessa funzione poichè la gestione è identica, Cambia solameanete il passaggio del impatto
    // a vuoto nella creazione.
    this.editElementoListaChk(idAmbito, idTematica);
  }

  async salvataggio(idAmbito: string, idTematica: string, idElemento: string) {
    try {
      // Salvo i dati modificati
      await firstValueFrom(this.salva(true));

      // Get dei dati aggiornati
      await firstValueFrom(this._getImpattiCheck());

      // Scroll all'elemento modificato
      setTimeout(() => {
        this.scrollToElement(idAmbito, idTematica, idElemento);
      }, 0);
    } catch (error) {
      console.error(error);
    }
  }

  private _getImpattiCheck() {
    this.spinnerOver.show();

    return this.materialitaService.getImpattiCheck(this.idContest).pipe(
      tap((esito) => {
        this.objQuestionario = esito;
      }),
      catchError(() => {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Errore nel recupero degli impatti',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return of();
      }),
      tap({
        finalize: () => this.spinnerOver.hide(),
      }),
    );
  }

  salva(noCtr?: boolean) {
    let impattiSelezionati = this.oggettoElementiSelezionati();

    if (!noCtr) {
      //Controllo se è stato selezionato almeno un impatto per tematica
      if (this.ctrElemChecked(impattiSelezionati, 'impatto')) {
        return of(false);
      }
    }

    return this._salvaSurveyElemSel(impattiSelezionati);
  }

  private _salvaSurveyElemSel(impattiSelezionati: any): Observable<boolean> {
    if (this.idContest) {
      return this.materialitaService.putImpattiCheck(this.idContest, impattiSelezionati).pipe(
        map((result: any) => {
          this.utilityService.openSnackBar('Aggiornamento effettuato', '', {
            duration: 2000,
            panelClass: ['success-snackbar'],
          });

          this.salvato.emit();

          return true;
        }),
        catchError((err: any) => {
          console.error('Errore :', err);

          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: err?.error?.message || 'Errore salvataggio (sconosciuto)',
            bottoni: [{ nome_btn: 'Ok' }],
          });

          return of(false);
        }),
      );
    } else {
      return of(false);
    }
  }

  override selezionaCheck(impatto: any, checked: boolean, idAmbito: string, idTematica: string) {
    if (this.stato !== 'PUBBLICATO' && !impatto.materiale) {
      if (
        this.isImpatto &&
        checked &&
        (!impatto.impattoPositivoNegativo?.length || !impatto.impattoPotenzialeEffettivo?.length)
      ) {
        impatto.selected = true;

        this._dialogCreaCfgImpatto(idAmbito, idTematica, impatto).subscribe((result) => {
          if (!result) {
            impatto.selected = false;
            checked = false;
          }
        });
      }

      impatto.selected = checked;
      this.updateFormStatus();
      this.ctrCheck(idAmbito, idTematica, impatto, checked);
    }
  }

  private _dialogCreaCfgImpatto(
    idAmbito: string,
    idTematica: string,
    impatto: Impatto,
  ): Observable<boolean> {
    const dialogCreaImpatto = this.dialog.open(DialogCreaCfgImpattoComponent, {
      data: {
        impatto,
        isFatturato: false,
        idContest: this.idContest,
        idAmbito,
        idTematica,
        contesto: 'materialita',
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '60%',
      maxHeight: '95%',
      autoFocus: false,
    });

    return dialogCreaImpatto.afterClosed().pipe(
      switchMap((result) => {
        if (result) {
          this.spinnerOver.show();
          this.salvataggio(idAmbito, idTematica, impatto?.id);
          return of(true);
        } else {
          return of(false);
        }
      }),
    );
  }
}
